import { Injectable } from '@angular/core';
import { ToasterService, BodyOutputType } from 'angular2-toaster';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toasterService: ToasterService
  ) {}

  public info(title: string, message?: string) {
    this.toasterService.pop('info', title, message);
  }

  public success(title: string, message?: string) {
    this.toasterService.pop('success', title, message);
  }

  public error(title: string, message?: string) {
    this.toasterService.pop('error', title, message);
  }

  public warning(title: string, message?: string) {
    this.toasterService.pop('warning', title, message);
  }

  public clear() {
    this.toasterService.clear();
  }

  public custom(title: string, message?: string, backgroundColor?: string, textColor?: string) {
    const styledMessage = `<div style="color: ${textColor || '#fff'};">${message}</div>`;
  
    this.injectCustomStyle(backgroundColor || '#333', textColor || '#fff');

    this.toasterService.pop({
      type: 'custom',
      title,
      body: styledMessage,
      bodyOutputType: BodyOutputType.TrustedHtml,
    });

    setTimeout(() => {
      const lastToast = document.querySelector('.toast:last-child') as HTMLElement;
      if (lastToast && !lastToast.classList.contains('toast-custom')) {
        lastToast.classList.add('toast-custom');
      }
      this.injectCustomStyle(backgroundColor || '#333', textColor || '#fff');
    }, 0);
  }

  private injectCustomStyle(backgroundColor: string, textColor: string) {
    const styleId = 'custom-toast-style';
    if (document.getElementById(styleId)) {
      document.getElementById(styleId)!.remove();
    }
  
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
      .toast-custom {
        background-color: ${backgroundColor} !important;
        color: ${textColor} !important;
      }
    `;
    document.head.appendChild(style);
  }
}